import React from 'react';
import { MDXProvider } from '@mdx-js/react';
import Callout from '../common_ui/Callout';
import LinkButton from '../common_ui/LinkButton';
import ExternalLinkButton from '../common_ui/ExternalLinkButton';
import EventSummary from '../common_ui/EventSummary';
import ProfileCard from '../content/ProfileCard';
import Remark from '../common_ui/Remark';
import MdxImage from '../common_ui/MdxImage';

interface LayoutProps {
  children: React.ReactNode;
}

const shortcodes = {
  Callout,
  LinkButton,
  ExternalLinkButton,
  EventSummary,
  ProfileCard,
  Remark,
  MdxImage,
};

const MainLayout: React.FC<LayoutProps> = ({ children }) => {
  return <MDXProvider components={shortcodes}>{children}</MDXProvider>;
};

export default MainLayout;
